// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__e62L7","projectInfo":"Footer_projectInfo__yn5gz","socialLinks":"Footer_socialLinks__o9SKB","links":"Footer_links__MvOVh"};